import { useCallback, useEffect, useState } from "react";
import { readHeightDisplayImperial, writeHeightDisplayImperial } from "./heightUtils";

const HEIGHT_DISPLAY_UNIT_EVENT = "yara:height-display-unit";

export function useHeightDisplayUnit() {
  const [useImperial, setUseImperialState] = useState(readHeightDisplayImperial);

  useEffect(() => {
    const sync = () => setUseImperialState(readHeightDisplayImperial());
    window.addEventListener("storage", sync);
    window.addEventListener(HEIGHT_DISPLAY_UNIT_EVENT, sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener(HEIGHT_DISPLAY_UNIT_EVENT, sync);
    };
  }, []);

  const setUseImperial = useCallback((next: boolean) => {
    writeHeightDisplayImperial(next);
    setUseImperialState(next);
    window.dispatchEvent(new Event(HEIGHT_DISPLAY_UNIT_EVENT));
  }, []);

  const toggle = useCallback(() => {
    setUseImperialState((current) => {
      const next = !current;
      writeHeightDisplayImperial(next);
      window.dispatchEvent(new Event(HEIGHT_DISPLAY_UNIT_EVENT));
      return next;
    });
  }, []);

  return { useImperial, setUseImperial, toggle };
}
